import message from "@/components/common/message/Message.vue";
import moment from 'moment'
import ShowObjectInfo from "@/components/object/showObjectInfo/showObjectInfo.vue";
import ActionComment from "@/components/object/comment/actionComment/ActionComment.vue";
import ShowObjectComment from "@/components/object/comment/objectComment/ShowObjectComment.vue";
import TableField from "@/components/common/table-field/TableField.vue";
export default {
    name: 'ObjectMonitoring',

    components: {
        TableField,
        ShowObjectInfo,
        message,
        ActionComment,
        ShowObjectComment
    },

    data() {
        return {
            isRedirectToSubscribe: false,
            seconds: 5,
            timer: null,
            loading: true,
            companyId: null,
            isStripeClient: null,
            objects: [],
            params: {
                page: 1,
                pageSize: this.getPageSize(),
                total: 0,
                sort_column: null,
                sort_direction: null,
                search: this.getSearch(),
            },
            controller: null,
            message: null,
            isVisibleMsg: false,
            isMsg: null,
        }
    },

    computed: {
        columns() {
            const cols = [
                { title: this.$t('object.monitoring.number'), key: "vehicleNumber", sortable: true, wrap: false },
                { title: this.$t('object.monitoring.name'), key: "name", sortable: true, wrap: false },
                { title: this.$t('object.monitoring.status'), key: "status", sortable: true, minWidth: "140px" },
                { title: this.$t('object.monitoring.comment'), key: "comment", sortable: true }
            ]

            if (this.isStripeClient) {
                const index = cols.findIndex(col => col.key === "status")
                if (index !== -1) {
                    cols.splice(index + 1, 0, {
                        title: this.$t('object.monitoring.activePeriod'),
                        key: "nextBillDate",
                        sortable: true
                    })
                }
            }

            if (this.isAdmin) {
                cols.push({
                    key: "actions",
                    minWidth: "100px",
                    actions: [
                        { emit: "showComment", icon: "bi bi-plus-circle", class: "btn-sm btn-primary", tooltip: "Show comment" },
                        { emit: "showObjectInfo", icon: "bi bi-info-circle", class: "btn-sm btn-info", tooltip: "Show object info" }
                    ]
                })
            }

            return cols;
        },

        globalCompanyId () {
            return this.$store.state.companyId;
        },

        isCanBuy() {
            return this.$store.getters.hasPermission('9a152d364b2887cdca803e6b3990449b');
        },

        isAdmin() {
            return this.$store.getters.hasPermission('21232f297a57a5a743894a0e4a801fc3');
        }
    },

    methods: {
        getPageSize() {
            const pageSize = localStorage.getItem('objectMonitoring-page-size');
            return pageSize ? Number(pageSize) : 20;
        },

        getSearch() {
            const search = localStorage.getItem('objectMonitoring_params_search');
            return search ? search : null;
        },

        async populateData() {
            this.loading = true;
            this.companyId = this.globalCompanyId == undefined ? '' : this.globalCompanyId;
            try {
                const response = await this.ApiRequest.requestAsync(
                    `object/monitoring/${this.companyId}`,
                    this.ApiRequest.REQUEST_POST,
                    this.params,
                    'my-vehicles-search',
                    true
                );

                if (!response || response.error || response.canceled) return;
                const { data, pagination } = response;
                this.isStripeClient = data.isStripeClient;
                await this.$nextTick();
                this.objects = this.BasicHelper.cloneObject(data.objects);
                this.params = {
                    ...this.params,
                    ...pagination
                }
            } finally {
                this.loading = false;
            }
        },

        async addComment(el, approved = false) {
            if (approved) {
                this.changeStatus(el);
            } else {
                if (this.isStripeClient && !this.isAdmin && el.status === '0') {
                    this.changeStatus(el);
                } else {
                    this.$refs.showActionComment.show({ objectId: el.objectId, status: el.status });
                }
            }
        },

        handleAction({ type, row }) {
            if (type === 'showComment') {
                this.showComment(row.objectId);
            }
            if (type === 'showObjectInfo') {
                this.showObjectInfo(row.billObjectId);
            }
        },

        showComment(objectId) {
            this.$refs.showObjectComment.show(objectId);
        },

        async changeStatus(el) {
            this.loading = true;
            this.isMsg = 'success';
            try {
                const { data } = await this.ApiRequest.requestAsync(
                    `object/status/${this.companyId}`,
                    this.ApiRequest.REQUEST_POST,
                    { objectId: el.objectId, status: el.status, comment: el.comment },
                    'change-status',
                    true
                );
                if (!data) return;

                if (data.redirect) {
                    this.redirectToSubscribe();
                } else if (data.url) {
                    window.location.replace(data.url);
                } else if (data.success) {
                    this.isVisibleMsg = true;
                    this.message = status === 1
                        ? this.$t('object.monitoring.status_disabled_successfully')
                        : this.$t('object.monitoring.status_enabled_successfully');
                    await this.populateData();
                }
            } finally {
                this.loading = false;
            }
        },

        changeIsVisibleMsg(isVisible) {
            this.isVisibleMsg = isVisible;
        },

        changeObject() {
            this.isVisibleMsg = true;
            this.isMsg = 'success';
            this.message = this.$t('showObjectInfo.msg_object_store_successfully')
            this.populateData();
        },

        async storeObjectToBilling(tavlObjectId) {
            this.loading = true;
            try {
                const response = await this.ApiRequest.requestAsync(
                    `object/store/${this.companyId}`,
                    this.ApiRequest.REQUEST_POST,
                    { tavlObjectId },
                    'store-object',
                    true
                );

                if (!response) return;
                if (response.data.success) {
                    this.message = this.$t('object.monitoring.store_successfully');
                    this.isMsg = 'success';
                    this.isVisibleMsg = true;
                    await this.populateData();
                } else {
                    this.message = this.$t('object.monitoring.store_msg_error');
                    this.isMsg = 'danger';
                    this.isVisibleMsg = true;
                }
            } finally {
                this.loading = false;
            }
        },

        async getBuyObject(tavlObjectId) {
            this.loading = true;
            try {
                const response = await this.ApiRequest.requestAsync(
                    `stripe/object/buy/${this.companyId}`,
                    this.ApiRequest.REQUEST_POST,
                    { tavlObjectId },
                    'buy-object',
                    true
                );

                if (!response) return;
                if (response.data.redirect) {
                    this.redirectToSubscribe();
                } else if (response.data.url) {
                    window.location.replace(response.data.url);
                } else if (response.data.error) {
                    this.message = response.data.error;
                    this.isMsg = 'danger';
                    this.isVisibleMsg = true;
                }
            } finally {
                this.loading = false;
            }
        },

        redirectToSubscribe() {
            this.isRedirectToSubscribe = true;
            this.timer = setInterval(() => {
                this.seconds--
                if (this.seconds === 0) {
                    clearInterval(this.timer)
                    this.$router.push('/billing/subscribe')
                }
            }, 1000);
        },

        isThisMonth(date) {
            return moment(date).isSame(moment(), 'month') || moment().isBefore(moment(date));
        },

        formatDate(date) {
            return moment(date).format('DD.MM.YYYY');
        },

        async showObjectInfo(billObjectId) {
            this.$refs.showObjectInfo.show(billObjectId, this.companyId);
        }
    },

    beforeUnmount() {
        clearInterval(this.timer)
    },

    beforeMount() {
        this.populateData();
    },

    watch: {
        globalCompanyId(val) {
            this.companyId = val;
            this.populateData();
        }
    }
}
